import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'iris-inline-loader',
  templateUrl: './inline-loader.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IrisInlineLoaderComponent {
  @Input() text: string;
}
